import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import menu from "../../assets/images/menu.svg";
import { NavLink, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { changeShowMenu } from "../../redux/slices/showMenuSlice";
import { fetchMenuGroup } from "../../redux/slices/menuGroupSlice";
import { fetchSettings } from "../../redux/slices/settingsSlice";
import API from "../../api";
import LanguageSelection from "./LanguageSelection";

const Header = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lang = useSelector((state) => state.lang.lang);
  const showMenu = useSelector((state) => state.showMenu.showMenu);
  const [isScrolled, setIsScrolled] = useState(false);

  const { dataMenuGroup } = useSelector((state) => state.menuGroup);
  const { dataSettings } = useSelector((state) => state.settings);

  const [logoImg, setLogoImg] = useState("");

  useEffect(() => {
    dispatch(fetchMenuGroup());
    dispatch(fetchSettings());

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [dispatch]);

  useEffect(() => {
    if (dataSettings && dataSettings.file) {
      setLogoImg(`${API.BASE}${dataSettings.file}`);
    }
  }, [dataSettings]);

  let headerMenus = [];

  if (Array.isArray(dataMenuGroup)) {
    const headerMenuGroup = dataMenuGroup.find(
      (group) => group?.title?.[lang] === "Header Menu"
    );
    if (headerMenuGroup && Array.isArray(headerMenuGroup.menus)) {
      headerMenus = headerMenuGroup.menus;
    }
  }

  return (
    <div className={`header ${isScrolled ? "header-scrolled" : ""}`}>
      <div className="logo">
        <Link to="/">
          <img src={logoImg} alt="Logo" />
        </Link>
      </div>
      <div className="menu">
        <ul>
          {headerMenus
            .slice()
            .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0))
            .map((menu) => (
              <li key={menu.id}>
                <NavLink
                  to={`/${menu.slug?.[lang] || ""}`}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  {menu.title?.[lang] || ""}
                </NavLink>
              </li>
            ))}

          <LanguageSelection />
        </ul>
      </div>
      <div className="mobile-selection d-flex justify-content-end align-items-center">
        <div>
          <LanguageSelection />
        </div>
        <div
          className="mobile-menu-btn ml-3"
          onClick={() => dispatch(changeShowMenu(!showMenu))}
        >
          <img src={menu} alt="Menu" />
        </div>
      </div>
    </div>
  );
};

export default Header;
